import { useEffect } from "react";
import { API } from "@/lib/api";

export const EXIT_URL = "https://www.google.com/search?q=weather";

export function quickExit() {
  try { navigator.sendBeacon(`${API}/auth/logout`, new Blob([], { type: "text/plain" })); } catch { /* best effort */ }
  try { sessionStorage.clear(); } catch { /* ignore */ }
  window.location.replace(EXIT_URL);
}

export function useEscapeTwiceToExit() {
  useEffect(() => {
    let lastEscape = 0;
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      const now = Date.now();
      if (now - lastEscape < 1500) quickExit();
      lastEscape = now;
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
}
